// extracted by mini-css-extract-plugin
export default {"title":"zXI4K_"};